// removed by extract-text-webpack-plugin
module.exports = {"title":"account-users__title___1GYHP","invite-button":"account-users__invite-button___3xCR3"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/settings/account-users.scss
// module id = 1353
// module chunks = 0